// App.jsx
import React, { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ProSidebarProvider } from "react-pro-sidebar";
import { ToastContainer } from "react-toastify";
import { IntlProvider } from "@progress/kendo-react-intl";
import { useSelector } from "react-redux";
import { useAppViewMode } from "hooks/useAppViewMode.jsx";
import { VIEW_MODES } from "CONSTANT/ViewModes/AppViewModes.js";
import { useCompany } from "services/companyService.js";
import { LoadLocaleData } from "./components/common/localeData";
import Layout from "./components/layout/Layout";
import AccessDenied from "components/common/Modal/AccessDenied";
import EventListenerComponent from "components/EventRegistrar";
import StandaloneDocumentViewer from "./pages/StandaloneDocumentViewer";
import StandaloneCaseFile from "pages/StandaloneCaseFile/index.jsx";
import StandaloneDashboard from "pages/StandaloneDashboard/index.jsx";
import StandaloneMatterLedger from "pages/StandaloneMatterLedger/index.jsx";
import ErrorDialog from "components/Error/ErrorDialog.jsx";
import Logout from "pages/Authentication/Logout.jsx";
import "@progress/kendo-theme-default/dist/all.css";
import "react-toastify/dist/ReactToastify.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.scss";

const App = () => {
  const [locale, setLocale] = useState("en-GB");
  const { status: accessDeniedStatus } = useSelector((state) => state.accessDenied);
  const { appViewMode } = useAppViewMode();
  const { data: company } = useCompany();

  useEffect(() => {
    if (company.locale) {
      setLocale(company.locale);
    }
  }, [company.locale]);

  useEffect(() => {
    if (appViewMode === VIEW_MODES.OUTLOOK) {
      import("./styles/_outlook.scss");
    }
  }, [appViewMode]);

  LoadLocaleData(company.locale);

  return (
    <IntlProvider locale={locale}>
      <ProSidebarProvider>
        <BrowserRouter>
          <EventListenerComponent />
          {accessDeniedStatus && <AccessDenied />}

          <Routes>
            <Route path="/logout" element={<Logout />} />
            <Route path="*" element={<Layout viewmode={appViewMode} />} />
            <Route
              path="/sa/document-viewer"
              element={<StandaloneDocumentViewer />}
            />
            <Route path="/sa/casefile/:id" element={<StandaloneCaseFile />} />
            <Route path="/sa/dashboard" element={<StandaloneDashboard />} />
            <Route
              path="/sa/matterledger/:id"
              element={<StandaloneMatterLedger />}
            />
            <Route
              path="/sa/matterledger"
              element={<StandaloneMatterLedger />}
            />
          </Routes>

          <ToastContainer
            closeButton
            toastStyle={{ marginRight: "70px", width: "100%" }}
            style={{ zIndex: 10010 }}
            hideProgressBar
            autoClose={2000}
          />

          <ErrorDialog />
        </BrowserRouter>
      </ProSidebarProvider>
    </IntlProvider>
  );
};

export default App;
